import { makeStyles } from '@mui/styles';
const closeButtonStyles = makeStyles(({ palette }) => ({
    icon: {
        fill: palette.primary.main,
    },
    closeIcon: {
        fill: palette.common.white,
    },
}), { name: 'Common_CloseButton' });
export default closeButtonStyles;
//# sourceMappingURL=closeButton.styles.js.map